import React from 'react';
import { object, string } from 'yup';

import { Form, Input, Button } from '../../components/_shared';
import MESSAGES from '../../locales';

const UserInfoSchema = object().shape({
  name: string().required(MESSAGES['name.presence']),
  email: string()
    .max(200, MESSAGES['email.invalid'])
    .email(MESSAGES['email.invalid'])
    .required(MESSAGES['email.presence']),
  username: string().required('Username is required.'),
});

const UserInfoForm = (props) => {
  return (
    <Form
      schema={UserInfoSchema}
      defaultValues={props.data}
      onSubmit={props.onSubmit}
    >
      <div className="mb-3">
        <Input
          id="name"
          name="name"
          label={MESSAGES['form.name']}
          type="text"
          autoComplete="off"
          required
        />
      </div>
      <div className="mb-3">
        <Input
          id="email"
          name="email"
          label={MESSAGES['form.email']}
          type="email"
          autoComplete="off"
          required
          readOnly
        />
      </div>
      <div className="mb-3">
        <Input
          id="username"
          name="username"
          label="Username"
          type="text"
          required
        />
      </div>
      <div className="flex flex-col mt-6">
        <Button
          className="rounded-lg"
          busy={props.isBusy}
          type="primary"
          caption="Save"
        />
      </div>
    </Form>
  );
};

export default UserInfoForm;
